export const PATH2 = "http://127.0.0.1:8999";
export const PATH = "https://pickpic.ru/back";
